<script setup lang="ts">
import { PhArrowLeft as ArrowLeft, PhCheck as Check, PhInfo as Info } from "@phosphor-icons/vue";
import { computed, ref } from "vue";
import BrandBar from "./BrandBar.vue";
import HomeButton from "./HomeButton.vue";
import { useSessionStore } from "../stores/session";

const store = useSessionStore();
const locked = ref(false);
const selected = computed(() => store.answers[store.currentQuestion.id]);

function choose(optionId: string) {
  if (locked.value) return;
  locked.value = true;
  store.choose(optionId);
  window.setTimeout(() => {
    store.next();
    locked.value = false;
  }, 360);
}
</script>

<template>
  <section class="screen screen--quiz">
    <header class="quiz-header">
      <button class="icon-button" aria-label="返回上一题" @click="store.previous"><ArrowLeft :size="22" weight="bold" /></button>
      <BrandBar compact />
      <HomeButton />
    </header>

    <div class="progress-track" aria-hidden="true">
      <span :style="{ width: `${store.progress * 100}%` }"></span>
    </div>

    <div class="question-stage">
      <div class="question-meta">
        <span>{{ store.currentQuestion.kicker }}</span>
        <span>第 {{ store.currentIndex + 1 }} 题</span>
      </div>
      <h1>{{ store.currentQuestion.prompt }}</h1>

      <div class="option-list" role="radiogroup" :aria-label="store.currentQuestion.prompt">
        <button
          v-for="(option, index) in store.currentQuestion.options"
          :key="option.id"
          class="option-card"
          :class="{ 'option-card--selected': selected === option.id }"
          :aria-checked="selected === option.id"
          role="radio"
          @click="choose(option.id)"
        >
          <span class="option-letter">{{ String.fromCharCode(65 + index) }}</span>
          <span class="option-copy">{{ option.label }}</span>
          <span class="option-check" aria-hidden="true"><Check :size="16" weight="bold" /></span>
        </button>
      </div>
    </div>

    <footer class="quiz-footer">
      <Info :size="16" weight="fill" /> 每题只选 1 个答案，选中后自动进入下一题
    </footer>
  </section>
</template>
